import { faSave } from "@fortawesome/free-solid-svg-icons";
import { type FC, useCallback, useState } from "react";
import { useApiCall } from "../api/api";
import { Input } from "../components/form/Input";
import { ModalFooter } from "../components/layout/ModalProvider";
import { useRefresh } from "../components/RefreshController";
import type { SelectedParticipantRow } from "../pages/BrowseAndFilterPage";

export const BulkSubcontractorRenameModal: FC<{ participants: SelectedParticipantRow[] }> = (
  props,
) => {
  const { bulkRenameSubcontractor } = useApiCall();
  const [subcontractorName, setSubcontractorName] = useState<string>("");
  const reload = useRefresh();
  const participantIds = props.participants.map((participant) => participant.id);
  const save = async () => {
    await bulkRenameSubcontractor(participantIds, subcontractorName);
    reload();
  };

  return (
    <>
      <Input
        type={"text"}
        label={"Subcontractor naam"}
        value={subcontractorName}
        onChange={setSubcontractorName}
      />
      <ModalFooter text={"Hernoemen"} icon={faSave} onSubmit={save} />
    </>
  );
};
